import { t as token } from "./auth.js";
import { a as PUBLIC_API_PATH, b as PUBLIC_APP_BASE } from "./public.js";
import { g as goto } from "./client.js";
import { r as redirect } from "./index.js";
let bearer = null;
if (token) {
  token.subscribe((t) => {
    bearer = t;
  });
}
const getOptions = (method, payload = null) => {
  const obj = {
    method: method.toUpperCase(),
    headers: {
      "Authorization": "bearer " + bearer,
      "Content-Type": "application/json"
    }
  };
  if (bearer) {
    obj.withCredentials = true;
  }
  if (payload) {
    obj.body = JSON.stringify(payload);
  }
  return obj;
};
const call = async (method, url, postData = null) => {
  const call2 = await fetch(PUBLIC_API_PATH + url, getOptions(method, postData));
  if (call2.status >= 200 && call2.status <= 299) {
    return await call2.json();
  } else if (call2.status === 401) {
    if (typeof document !== "undefined") {
      await goto();
    } else {
      throw redirect(300, PUBLIC_APP_BASE);
    }
  } else {
    throw Error(call2.statusText);
  }
};
const post = async (url, postData = {}) => call("post", url, postData);
const get = async (url) => call("get", url);
const retire = async (url) => call("delete", url);
const put = async (url, postData = {}) => call("put", url, postData);
const formDataPost = async (url, postData) => {
  const options = getOptions("post");
  delete options.headers["Content-Type"];
  const data = new FormData();
  for (const name in postData) {
    data.append(name, postData[name]);
  }
  options.body = data;
  const call2 = await fetch(PUBLIC_API_PATH + url, options);
  if (call2.status >= 200 && call2.status <= 299) {
    return await call2.json();
  }
  throw Error(call2.statusText);
};
export {
  put as a,
  formDataPost as f,
  get as g,
  post as p,
  retire as r
};
//# sourceMappingURL=api.js.map
